import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  CalendarClock,
  Plus,
  Users,
  BarChart,
  Layers,
  Clock,
  TrendingUp,
  MapPin,
  ChevronRight,
  UserPlus,
  Calendar,
  Star,
  CreditCard,
} from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import EventCard, { EventCardProps } from "@/components/EventCard";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useToast } from "@/components/ui/use-toast";
import { SubscriptionPlan } from "@/components/subscription/SubscriptionPlans";
import EventsTab from "./EventsTab";
import {
  countAttendees,
  listViewEvents,
  listTeamMembers,
  countTeamMembers,
} from "@/services/eventsServiices";
import { getCurrentClientData } from "@/services/authServices";
import { EventsService } from "@/api/events";
import { cn } from "@/lib/utils";

interface User {
  name?: string;
  email: string;
}

interface TeamMember {
  id?: string;
  first_name: string;
  last_name: string;
  email: string;
  role: string;
  dateAdded: string;
  avatar?: string;
  created_at?: string;
}

const Dashboard = () => {
  const { toast } = useToast();
  const loggedInUser = getCurrentClientData();
  const { postMembers, getEvents } = EventsService;

  const [user, setUser] = useState<User | null>(null);
  const [upcomingEvents, setUpcomingEvents] = useState(0);
  const [upcomingEventText, setUpcomingEventText] = useState(0);
  const [totalAttendees, setTotalAttendees] = useState(0);
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([]);
  const [activeTab, setActiveTab] = useState("overview");
  const [userPlan, setUserPlan] = useState<SubscriptionPlan>(freePlan);
  const [loading, setLoading] = useState(false);
  const [loadEvent, setLoadEvent] = useState(false);
  const [open, setOpen] = useState(false);
  const [eventsList, setEventsList] = useState([]);

  const [inviteFormData, setInviteFormData] = useState({
    email: "",
    role: "viewer", // Default role
    first_name: "",
    last_name: "",
    message: "",
  });

  const fetchUpcomingEvent = async () => {
    try {
      const res: any = await listViewEvents(loggedInUser.token);

      if (res.data.statusCode === 200) {
        setUpcomingEvents(res.data.body.upcoming_events);
        setUpcomingEventText(res.data.body.this_week_events);
      } else {
        setUpcomingEvents(0);
        setUpcomingEventText(0);
      }
    } catch (error) {
      setUpcomingEvents(0);
      setUpcomingEventText(0);
    }
  };

  const getCountTeamMembers = async () => {
    try {
      const res: any = await countTeamMembers(loggedInUser.token);
      console.log("res", res);
      if (res.data.statusCode === 200) {
        // setTeamMembers(res.data.body.members);
      } else {
        // setTeamMembers([]);
      }
    } catch (error) {
      // setTeamMembers([]);
    }
  };
  const getAttendes = async () => {
    try {
      const res: any = await countAttendees(loggedInUser.token);

      if (res.data.statusCode === 200) {
        setTotalAttendees(res.data.body.attendee_count);
      } else {
        setTotalAttendees(0);
      }
    } catch (error) {
      setTotalAttendees(0);
    }
  };

  const getListTeamMembers = async () => {
    try {
      const res: any = await listTeamMembers(loggedInUser.token);
      if (res.data.statusCode === 200) {
        setTeamMembers(res.data.body.team_members); //// here
      } else {
        setTeamMembers([]);
      }
    } catch (error) {
      setTeamMembers([]);
    }
  };

  const loadAllEventsFn = async () => {
    setLoadEvent(true);

    try {
      const res: any = await getEvents(loggedInUser?.token);

      if (res.statusCode === 200 || res.statusCode === 201) {
        setEventsList(res.body.events);
      } else {
        toast({
          title: "Error",
          description:
            res.body.message || "There was an error creating your event.",
          variant: "destructive",
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "There was an error creating your event.",
        variant: "destructive",
      });
      return;
    } finally {
      setLoadEvent(false);
    }
  };
  useEffect(() => {
    fetchUpcomingEvent();
    getAttendes();
    getListTeamMembers();
    getCountTeamMembers();
    loadAllEventsFn();
  }, []);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }

    // setTeamMembers([
    //   {
    //     id: "user-1",
    //     name: "Alex Johnson",
    //     email: "alex@example.com",
    //     role: "Admin",
    //     dateAdded: "2023-08-15",
    //     avatar: "https://i.pravatar.cc/150?img=1",
    //   },
    //   {
    //     id: "user-2",
    //     name: "Sarah Williams",
    //     email: "sarah@example.com",
    //     role: "Event Manager",
    //     dateAdded: "2023-09-05",
    //     avatar: "https://i.pravatar.cc/150?img=5",
    //   },
    //   {
    //     id: "user-3",
    //     name: "Michael Chen",
    //     email: "michael@example.com",
    //     role: "Viewer",
    //     dateAdded: "2023-10-20",
    //     avatar: "https://i.pravatar.cc/150?img=8",
    //   },
    // ]);
  }, []);

  const mockEvents = [
    {
      id: "evt-1",
      title: "Annual Tech Conference",
      date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toLocaleDateString(),
      time: "09:00 AM - 05:00 PM",
      attendees: 65,
      maxAttendees: 100,
      location: "San Francisco, CA",
      description:
        "Join us for the latest trends and innovations in technology.",
      image:
        "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=800&q=80",
      price: "Free",
      category: "Technology",
      isDigital: true,
    },
    {
      id: "evt-2",
      title: "Startup Networking Mixer",
      date: new Date(
        Date.now() + 14 * 24 * 60 * 60 * 1000
      ).toLocaleDateString(),
      time: "06:30 PM - 09:00 PM",
      attendees: 42,
      maxAttendees: 50,
      location: "New York, NY",
      description:
        "Connect with other entrepreneurs and investors in a casual setting.",
      image:
        "https://images.unsplash.com/photo-1551818255-e6e10975bc17?auto=format&fit=crop&w=800&q=80",
      price: "$15",
      category: "Networking",
    },
    {
      id: "evt-3",
      title: "Product Launch Party",
      date: new Date(
        Date.now() + 21 * 24 * 60 * 60 * 1000
      ).toLocaleDateString(),
      time: "07:00 PM - 10:00 PM",
      attendees: 17,
      maxAttendees: 75,
      location: "Austin, TX",
      description: "Be the first to experience our revolutionary new product.",
      image:
        "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=800&q=80",
      price: "$25",
      category: "Product",
    },
  ];

  const featuredEvent = {
    id: "evt-featured",
    title: "Annual Innovation Summit",
    description:
      "Join industry leaders and innovators for this exclusive event featuring keynote speakers and hands-on workshops.",
    date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString(),
    time: "09:00 AM - 06:00 PM",
    location: "Seattle, WA",
    image:
      "https://images.unsplash.com/photo-1531058020387-3be344556be6?auto=format&fit=crop&w=800&q=80",
    attendees: 89,
    maxAttendees: 150,
    price: "$99",
    category: "Conference",
    featured: true,
    isDigital: true,
  };

  const handleInviteMemeber = async () => {
    setLoading(true);

    try {
      const res: any = await postMembers(loggedInUser.token, {
        email: inviteFormData.email,
        role: inviteFormData.role,
        first_name: inviteFormData.first_name,
        last_name: inviteFormData.last_name,
        custom_message: inviteFormData.message,
      });

      if (res?.statusCode === 200) {
        setOpen(false);
        toast({
          title: "Invitation Sent",
          description: "The invitation has been sent to the team member.",
        });
        setLoading(false);
        setInviteFormData({
          email: "",
          role: "",
          first_name: "",
          last_name: "",
          message: "",
        });
      } else {
        setOpen(false);
        toast({
          variant: "destructive",
          title: "Error",
          description:
            res.body.message ||
            res.body.errors.role ||
            res.body.errors.email ||
            res.body.errors.first_name ||
            res.body.errors.last_name ||
            res.body.errors.custom_message,
        });
        setLoading(false);
        setInviteFormData({
          email: "",
          role: "",
          first_name: "",
          last_name: "",
          message: "",
        });
      }
    } catch (error) {
      setOpen(false);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to send the invitation",
      });
      setLoading(false);
      setInviteFormData({
        email: "",
        role: "",
        first_name: "",
        last_name: "",
        message: "",
      });
    }
  };
  const handleUpgradePlan = () => {
    window.location.href = "/billing";
  };
  const handleInputChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = event.target;
    setInviteFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const rawRandomEvent =
    eventsList.length > 0
      ? eventsList[Math.floor(Math.random() * eventsList.length)]
      : null;

  const mappedEvent = rawRandomEvent
    ? {
        id: rawRandomEvent.event_id,
        title: rawRandomEvent.event_title,
        description: rawRandomEvent.event_description,
        date: new Date(rawRandomEvent.event_date).toLocaleDateString(),
        time: `${rawRandomEvent.start_time} - ${rawRandomEvent.end_time}`,
        location: rawRandomEvent.location,
        image: rawRandomEvent.img_url?.[0] || "/placeholder.jpg", // fallback image
        attendees: parseInt(rawRandomEvent.attendees || "0"),
        // maxAttendees: parseInt(rawRandomEvent.max_attendees || "0"),
        price: `$${rawRandomEvent.ticket_price}`,
        category: rawRandomEvent.category,
        virtual_event: rawRandomEvent.virtual_event,
      }
    : null;

  const LoadingSpinner = () => (
    <div className="flex items-center justify-center h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
    </div>
  );
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
            <p className="text-gray-600 mt-1">
              Welcome back, {user?.name || user?.email || "Event Organizer"}
            </p>
          </div>
          <div className="mt-4 md:mt-0 flex space-x-3">
            <Link to="/create">
              <Button className="bg-cecure-700 hover:bg-cecure-800">
                <Plus className="h-4 w-4 mr-1" /> Create Event
              </Button>
            </Link>
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <Button disabled={true} variant="outline" className="relative">
                  <UserPlus className="h-4 w-4 mr-1" /> Invite Team Member
                  <span className="absolute -top-2 text-xs bg-blue-100 text-blue-800 dark:bg-amber-900/30 dark:text-blue-200 px-2 rounded-full">
                    Coming soon ✨
                  </span>
                </Button>
              </SheetTrigger>
              <SheetContent>
                <SheetHeader>
                  <SheetTitle>Invite Team Member</SheetTitle>
                  <SheetDescription>
                    Add a new team member to collaborate on your events.
                  </SheetDescription>
                </SheetHeader>
                <div className="grid gap-4 py-4">
                  <div className="space-y-2">
                    <h3 className="text-sm font-medium">Email</h3>
                    <input
                      type="email"
                      placeholder="colleague@example.com"
                      name="email"
                      value={inviteFormData.email}
                      onChange={handleInputChange}
                      className="w-full rounded-md border border-gray-300 p-2"
                    />
                  </div>
                  <div className="space-y-2">
                    <h3 className="text-sm font-medium">Role</h3>
                    <select
                      className="w-full rounded-md border border-gray-300 p-2"
                      name="role"
                      value={inviteFormData.role}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>
                        Select a role
                      </option>
                      <option value="admin">Admin</option>
                      <option value="manager">Event Manager</option>
                      <option value="viewer">Viewer</option>
                    </select>
                  </div>
                  <div className="space-y-2">
                    <h3 className="text-sm font-medium">First Name</h3>
                    <input
                      type="text"
                      placeholder="John"
                      name="first_name"
                      className="w-full rounded-md border border-gray-300 p-2"
                      value={inviteFormData.first_name}
                      onChange={handleInputChange}
                    />
                  </div>{" "}
                  <div className="space-y-2">
                    <h3 className="text-sm font-medium">Last Name</h3>
                    <input
                      type="text"
                      name="last_name"
                      placeholder="Doe"
                      className="w-full rounded-md border border-gray-300 p-2"
                      value={inviteFormData.last_name}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="space-y-2">
                    <h3 className="text-sm font-medium">
                      Custom Message (Optional)
                    </h3>
                    <textarea
                      name="message"
                      value={inviteFormData.message}
                      onChange={handleInputChange}
                      placeholder="I'd like to invite you to collaborate on my events..."
                      className="w-full rounded-md border border-gray-300 p-2 h-24"
                    />
                  </div>
                  <Button
                    disabled={loading}
                    className="w-full mt-4"
                    onClick={handleInviteMemeber}
                  >
                    Send Invitation
                  </Button>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>

        <Tabs
          defaultValue="overview"
          className="mb-8"
          onValueChange={setActiveTab}
        >
          <TabsList className="mb-6">
            <TabsTrigger value="overview">Overview</TabsTrigger>
            <TabsTrigger value="events">Events</TabsTrigger>
            <TabsTrigger value="team">Team Management</TabsTrigger>
            <TabsTrigger value="subscription">Subscription</TabsTrigger>
          </TabsList>

          <TabsContent value="overview" className="space-y-8">
            <Alert className="bg-cecure-50 border-cecure-200">
              {loggedInUser?.account_type?.account_type === "standard" && (
                <>
                  <Star className="h-4 w-4 text-cecure-700" />
                  <AlertTitle className="text-cecure-700">
                    Upgrade your plan
                  </AlertTitle>
                </>
              )}
              <AlertDescription className="text-cecure-600">
                {loggedInUser?.account_type?.account_type === "standard" && (
                  <>
                    You're currently on the Free plan. Upgrade to Pro for
                    unlimited events, custom branding, and more.
                  </>
                )}
                <div className="mt-2">
                  <Button
                    size="sm"
                    className="bg-cecure-700 hover:bg-cecure-800"
                    onClick={handleUpgradePlan}
                  >
                    View Plans
                  </Button>
                </div>
              </AlertDescription>
            </Alert>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
              <Card>
                <CardHeader className="flex flex-row items-center justify-between pb-2">
                  <CardTitle className="text-sm font-medium">
                    Upcoming Events
                  </CardTitle>
                  <CalendarClock className="h-4 w-4 text-muted-foreground" />
                </CardHeader>
                <CardContent>
                  <div className="text-2xl font-bold">{upcomingEvents}</div>
                  <p className="text-xs text-muted-foreground mt-1">
                    {upcomingEventText} events this week
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader className="flex flex-row items-center justify-between pb-2">
                  <CardTitle className="text-sm font-medium">
                    Total Attendees
                  </CardTitle>
                  <Users className="h-4 w-4 text-muted-foreground" />
                </CardHeader>
                <CardContent>
                  <div className="text-2xl font-bold">{totalAttendees}</div>
                  <p className="text-xs text-muted-foreground mt-1">
                    +12% from last month
                  </p>
                </CardContent>
              </Card>
              {/* 
              <Card>
                <CardHeader className="flex flex-row items-center justify-between pb-2">
                  <CardTitle className="text-sm font-medium">
                    Engagement Rate
                  </CardTitle>
                  <BarChart className="h-4 w-4 text-muted-foreground" />
                </CardHeader>
                <CardContent>
                  <div className="text-2xl font-bold">87%</div>
                  <p className="text-xs text-muted-foreground mt-1">
                    +5% from last month
                  </p>
                </CardContent>
              </Card> */}

              <Card>
                <CardHeader className="flex flex-row items-center justify-between pb-2">
                  <CardTitle className="text-sm font-medium">
                    Team Members
                  </CardTitle>
                  <Users className="h-4 w-4 text-muted-foreground" />
                </CardHeader>
                <CardContent>
                  <div className="text-2xl font-bold">{teamMembers.length}</div>
                  <p className="text-xs text-muted-foreground mt-1">
                    Active collaborators
                  </p>
                </CardContent>
              </Card>
            </div>

            <div>
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">Featured Event</h2>
                <Link
                  to="/events"
                  className="text-sm text-cecure-700 hover:text-cecure-800 flex items-center"
                >
                  View all events <ChevronRight className="h-4 w-4 ml-1" />
                </Link>
              </div>
              <>
                {loadEvent ? (
                  <LoadingSpinner />
                ) : (
                  <div className="grid md:grid-cols-2 gap-6">
                    {/* <EventCard {...(featuredEvent as EventCardProps)} /> */}
                    {mappedEvent && (
                      <EventCard
                        {...(mappedEvent as EventCardProps)}
                        actions={[]}
                      />
                    )}

                    <Card>
                      <CardHeader>
                        <CardTitle>Quick Actions</CardTitle>
                        <CardDescription>
                          Common tasks you might want to perform
                        </CardDescription>
                      </CardHeader>
                      <CardContent className="grid gap-4">
                        <Link
                          to="/create"
                          className="flex items-center p-3 hover:bg-gray-50 rounded-md transition-colors"
                        >
                          <div className="bg-cecure-100 p-2 rounded-md mr-4">
                            <Calendar className="h-5 w-5 text-cecure-700" />
                          </div>
                          <div>
                            <h3 className="text-sm font-medium">
                              Create New Event
                            </h3>
                            <p className="text-xs text-muted-foreground">
                              Set up a new event or workshop
                            </p>
                          </div>
                          <ChevronRight className="h-4 w-4 ml-auto text-muted-foreground" />
                        </Link>

                        <Link
                          to={`/events`}
                          className="flex items-center p-3 hover:bg-gray-50 rounded-md transition-colors"
                        >
                          <div className="bg-cecure-100 p-2 rounded-md mr-4">
                            <Layers className="h-5 w-5 text-cecure-700" />
                          </div>
                          <div>
                            <h3 className="text-sm font-medium">
                              Manage Existing Event
                            </h3>
                            <p className="text-xs text-muted-foreground">
                              Edit details or update attendees
                            </p>
                          </div>
                          <ChevronRight className="h-4 w-4 ml-auto text-muted-foreground" />
                        </Link>

                        {/* <div
                          to="/event/evt-1/attendees"
                          className="flex items-center p-3 hover:bg-gray-50 rounded-md transition-colors"
                        >
                          <div className="bg-cecure-100 p-2 rounded-md mr-4">
                            <Users className="h-5 w-5 text-cecure-700" />
                          </div>
                          <div>
                            <h3 className="text-sm font-medium">
                              Manage Attendees
                            </h3>
                            <p className="text-xs text-muted-foreground">
                              View and export attendee lists
                            </p>
                          </div>
                          <ChevronRight className="h-4 w-4 ml-auto text-muted-foreground" />
                        </div> */}

                        <Link
                          to="/profile"
                          className="flex items-center p-3 hover:bg-gray-50 rounded-md transition-colors"
                        >
                          <div className="bg-cecure-100 p-2 rounded-md mr-4">
                            <Star className="h-5 w-5 text-cecure-700" />
                          </div>
                          <div>
                            <h3 className="text-sm font-medium">
                              Account Settings
                            </h3>
                            <p className="text-xs text-muted-foreground">
                              Update your profile or billing
                            </p>
                          </div>
                          <ChevronRight className="h-4 w-4 ml-auto text-muted-foreground" />
                        </Link>
                      </CardContent>
                    </Card>
                  </div>
                )}
              </>
            </div>

            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="flex items-center justify-between px-6 py-4 border-b">
                <h2 className="text-lg font-medium">Your Upcoming Events</h2>
                <Link to="/events">
                  <Button variant="outline" size="sm">
                    View All Events
                  </Button>
                </Link>
              </div>

              <>
                {loadEvent ? (
                  <LoadingSpinner />
                ) : (
                  <ul className="divide-y divide-gray-200">
                    {eventsList.slice(0, 3).map((event) => (
                      <li
                        key={event.event_id}
                        className="px-6 py-4 hover:bg-gray-50 transition-colors"
                      >
                        <div className="flex items-center justify-between">
                          <div>
                            <h3 className="text-lg font-medium text-gray-900">
                              {event.event_title}
                              {event.virtual_event === "Yes" && (
                                <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                                  Digital
                                </span>
                              )}
                            </h3>
                            <div className="flex mt-1 text-sm text-gray-500 space-x-4">
                              <span className="flex items-center">
                                <Clock className="h-4 w-4 mr-1" />
                                {event.event_date}
                              </span>
                              {event.location && (
                                <span className="flex items-center">
                                  <MapPin className="h-4 w-4 mr-1" />
                                  {event.location}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="flex space-x-2">
                            <Link to={`/dashboard/${event.event_id}`}>
                              <Button variant="outline" size="sm">
                                Manage
                              </Button>
                            </Link>
                            {event.virtual_event === "Yes" && (
                              <Link to={`/digital-event/${event.event_id}`}>
                                <Button
                                  size="sm"
                                  className="bg-cecure-700 hover:bg-cecure-800"
                                >
                                  Join Digital Event
                                </Button>
                              </Link>
                            )}
                            {/* <Link to={`/event/${event.id}/attendees`}> */}
                            <Button
                              size="sm"
                              variant="outline"
                              className="flex items-center"
                            >
                              <Users className="h-4 w-4 mr-1" />{" "}
                              {event.attendees}
                            </Button>
                            {/* </Link> */}
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </>
            </div>
          </TabsContent>

          <TabsContent value="events" className="space-y-6">
            <EventsTab />
          </TabsContent>

          <TabsContent value="team" className="space-y-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Team Management</h2>
              <Sheet>
                <SheetTrigger asChild>
                  <Button>
                    <UserPlus className="h-4 w-4 mr-1" /> Add Team Member
                  </Button>
                </SheetTrigger>
                <SheetContent>
                  <SheetHeader>
                    <SheetTitle>Add Team Member</SheetTitle>
                    <SheetDescription>
                      Invite a new team member to collaborate on your events.
                    </SheetDescription>
                  </SheetHeader>
                  <div className="grid gap-4 py-4">
                    <div className="space-y-2">
                      <h3 className="text-sm font-medium">Email</h3>
                      <input
                        type="email"
                        placeholder="colleague@example.com"
                        name="email"
                        value={inviteFormData.email}
                        onChange={handleInputChange}
                        className="w-full rounded-md border border-gray-300 p-2"
                      />
                    </div>
                    <div className="space-y-2">
                      <h3 className="text-sm font-medium">Role</h3>
                      <select
                        className="w-full rounded-md border border-gray-300 p-2"
                        name="role"
                        value={inviteFormData.role}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled>
                          Select a role
                        </option>
                        <option value="admin">Admin</option>
                        <option value="manager">Event Manager</option>
                        <option value="viewer">Viewer</option>
                      </select>
                    </div>
                    <div className="space-y-2">
                      <h3 className="text-sm font-medium">First Name</h3>
                      <input
                        type="text"
                        placeholder="John"
                        name="first_name"
                        className="w-full rounded-md border border-gray-300 p-2"
                        value={inviteFormData.first_name}
                        onChange={handleInputChange}
                      />
                    </div>{" "}
                    <div className="space-y-2">
                      <h3 className="text-sm font-medium">Last Name</h3>
                      <input
                        type="text"
                        name="last_name"
                        placeholder="Doe"
                        className="w-full rounded-md border border-gray-300 p-2"
                        value={inviteFormData.last_name}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="space-y-2">
                      <h3 className="text-sm font-medium">
                        Custom Message (Optional)
                      </h3>
                      <textarea
                        name="message"
                        value={inviteFormData.message}
                        onChange={handleInputChange}
                        placeholder="I'd like to invite you to collaborate on my events..."
                        className="w-full rounded-md border border-gray-300 p-2 h-24"
                      />
                    </div>
                    <Button
                      className="w-full mt-4"
                      onClick={handleInviteMemeber}
                    >
                      Send Invitation
                    </Button>
                  </div>
                </SheetContent>
              </Sheet>
            </div>

            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="px-4 py-5 sm:px-6 border-b">
                <h3 className="text-lg font-medium">Current Team Members</h3>
                <p className="mt-1 text-sm text-gray-500">
                  Manage access and permissions for your team
                </p>
              </div>
              <ul className="divide-y divide-gray-200">
                {teamMembers.map((member) => (
                  <li
                    key={member.id}
                    className="px-4 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <div className="flex items-center">
                      <div className="flex-shrink-0 h-10 w-10">
                        <img
                          className="h-10 w-10 rounded-full"
                          src={
                            member.avatar ||
                            `https://ui-avatars.com/api/?name=${encodeURIComponent(
                              member.first_name
                            )}&background=random`
                          }
                          alt={member.first_name}
                        />
                      </div>
                      <div className="ml-4">
                        <div className="text-sm font-medium text-gray-900">
                          {member.first_name} {member.last_name}
                        </div>
                        <div className="text-sm text-gray-500">
                          {member.email}
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center space-x-4">
                      <span className="px-2 py-1 text-xs rounded-full bg-gray-100">
                        {member.role}
                      </span>
                      <div className="text-sm text-gray-500">
                        Added {new Date(member.created_at).toLocaleDateString()}
                      </div>
                      {/* <Button variant="outline" size="sm">
                        Manage
                      </Button> */}
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <Card>
              <CardHeader>
                <CardTitle>Roles and Permissions</CardTitle>
                <CardDescription>
                  Understanding access levels for team members
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div className="p-4 border rounded-md">
                    <h4 className="font-medium">Admin</h4>
                    <p className="text-sm text-gray-500 mt-1">
                      Full access to create, edit, and delete events, manage
                      team members, and access billing information.
                    </p>
                  </div>
                  <div className="p-4 border rounded-md">
                    <h4 className="font-medium">Event Manager</h4>
                    <p className="text-sm text-gray-500 mt-1">
                      Can create and edit events, manage attendees, and view
                      reports, but cannot manage team members or billing.
                    </p>
                  </div>
                  <div className="p-4 border rounded-md">
                    <h4 className="font-medium">Viewer</h4>
                    <p className="text-sm text-gray-500 mt-1">
                      Read-only access to events and attendee information.
                      Cannot create or edit events or manage team members.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="subscription" className="space-y-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Your Current Plan</h2>
              <Link to="/billing">
                <Button>
                  <CreditCard className="h-4 w-4 mr-1" /> Manage Subscriptions
                </Button>
              </Link>
            </div>

            <div className="grid grid-cols-1 gap-6">
              <Card>
                <CardHeader>
                  <div className="flex justify-between items-center">
                    <div>
                      <CardTitle className="capitalize">
                        {loggedInUser?.account_type?.account_type} Plan
                      </CardTitle>
                      <CardDescription>{userPlan.description}</CardDescription>
                    </div>

                    <div className="flex flex-col items-end gap-1">
                      <span
                        className={cn(
                          "bg-green-100 text-green-800 text-xs font-semibold px-3 py-1 rounded-full capitalize",
                          {
                            "bg-gray-100 text-gray-800":
                              loggedInUser?.account_type?.status === "inactive",
                          }
                        )}
                      >
                        {loggedInUser?.account_type?.status}
                      </span>
                      {loggedInUser?.account_type?.valid_until && (
                        <span className="bg-gray-100 text-gray-800 text-xs font-semibold px-3 py-1 rounded-full">
                          <span className="font-bold">Valid Till:</span>{" "}
                          {new Date(
                            loggedInUser?.account_type?.valid_until
                          ).toLocaleString("en-GB")}
                        </span>
                      )}
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    <div>
                      <h3 className="text-sm font-medium mb-2">
                        Plan includes:
                      </h3>
                      {loggedInUser?.account_type?.account_type === "free" ? (
                        <>
                          <ul className="space-y-2">
                            {userPlan.features
                              .filter((f) => f.included)
                              .map((feature, idx) => (
                                <li
                                  key={idx}
                                  className="flex items-center text-sm"
                                >
                                  <div className="bg-green-100 p-1 rounded-full mr-2">
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M20 6L9 17L4 12"
                                        stroke="#16A34A"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>
                                  {feature.name}
                                </li>
                              ))}
                          </ul>
                        </>
                      ) : (
                        <>
                          <ul className="space-y-2">
                            {proPlan.features
                              .filter((f) => f.included)
                              .map((feature, idx) => (
                                <li
                                  key={idx}
                                  className="flex items-center text-sm"
                                >
                                  <div className="bg-green-100 p-1 rounded-full mr-2">
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M20 6L9 17L4 12"
                                        stroke="#16A34A"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>
                                  {feature.name}
                                </li>
                              ))}
                          </ul>
                        </>
                      )}
                    </div>

                    {loggedInUser?.account_type?.account_type === "free" && (
                      <div>
                        <h3 className="text-sm font-medium mb-2">
                          Upgrade to unlock:
                        </h3>
                        <ul className="space-y-2">
                          {freePlan.features
                            .filter(
                              (f) =>
                                f.included &&
                                !userPlan.features.find(
                                  (uf) => uf.included && uf.name === f.name
                                )
                            )
                            .slice(0, 4)
                            .map((feature, idx) => (
                              <li
                                key={idx}
                                className="flex items-center text-sm text-gray-500"
                              >
                                <div className="bg-gray-100 p-1 rounded-full mr-2">
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12 5V19M5 12H19"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </div>
                                {feature.name}
                              </li>
                            ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </CardContent>
                <CardFooter>
                  <Link to="/billing" className="w-full">
                    <Button className="w-full bg-cecure-700 hover:bg-cecure-800">
                      {loggedInUser?.account_type?.account_type === "standard"
                        ? "Upgrade Plan"
                        : "Manage Subscription"}
                    </Button>
                  </Link>
                </CardFooter>
              </Card>

              <div className="bg-white p-6 rounded-lg shadow-sm border">
                <h3 className="text-lg font-medium mb-4">Why Upgrade?</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="p-4 border rounded-md">
                    <div className="bg-cecure-100 p-2 w-10 h-10 rounded-full flex items-center justify-center mb-3">
                      <Calendar className="h-5 w-5 text-cecure-700" />
                    </div>
                    <h4 className="font-medium mb-1">Unlimited Events</h4>
                    <p className="text-sm text-gray-600">
                      Create and manage as many events as you need.
                    </p>
                  </div>
                  <div className="p-4 border rounded-md">
                    <div className="bg-cecure-100 p-2 w-10 h-10 rounded-full flex items-center justify-center mb-3">
                      <Users className="h-5 w-5 text-cecure-700" />
                    </div>
                    <h4 className="font-medium mb-1">More Attendees</h4>
                    <p className="text-sm text-gray-600">
                      Host larger events with unlimited attendees.
                    </p>
                  </div>
                  <div className="p-4 border rounded-md">
                    <div className="bg-cecure-100 p-2 w-10 h-10 rounded-full flex items-center justify-center mb-3">
                      <Star className="h-5 w-5 text-cecure-700" />
                    </div>
                    <h4 className="font-medium mb-1">Custom Branding</h4>
                    <p className="text-sm text-gray-600">
                      Personalize your event pages with your own brand.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

const freePlan: SubscriptionPlan = {
  id: "free",
  name: "Free",
  description: "For individuals and small events",
  price: "Free",
  billingPeriod: "monthly",
  features: [
    { name: "Up to 3 events per month", included: true },
    { name: "Basic event management", included: true },
    { name: "Up to 50 attendees per event", included: true },
    { name: "Email support", included: true },
    { name: "Custom branding", included: false },
    { name: "Advanced analytics", included: false },
    { name: "Priority support", included: false },
    { name: "Unlimited team members", included: false },
  ],
  buttonText: "Get Started",
};

const proPlan: SubscriptionPlan = {
  id: "pro",
  name: "Pro",
  description: "For growing businesses and regular events",
  price: 19.99,
  billingPeriod: "monthly",
  features: [
    { name: "Unlimited events", included: true, highlight: true },
    { name: "Advanced event management", included: true },
    { name: "Up to 500 attendees per event", included: true },
    { name: "Email + chat support", included: true },
    { name: "Custom branding", included: true },
    { name: "Basic analytics", included: true },
    { name: "3 team members", included: true },
    { name: "Priority support", included: false },
  ],
  popular: true,
  buttonText: "Upgrade to Pro",
};

export default Dashboard;
